import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import { useTranslation } from 'react-i18next';


function Timeline() {
      const {t} = useTranslation();
  return (
    <div id="history">
      <div className="items-container">
      <h1>{t('careerHistory')}</h1>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
          contentArrowStyle={{ borderRight: '7px solid  white' }}
          date="2020 - 2023"
          iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">{t('webEngineer')}</h3>
          <h4 className="vertical-timeline-element-subtitle">{t('tacoma')}</h4>
          <p>{t('webEngineerDetails')}</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2019 - 2020"
          iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">{t('fullstackIntern')}</h3>
          <h4 className="vertical-timeline-element-subtitle">{t('lacey')}</h4>
          <p>{t('fullstackInternDetails')}</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2017 - 2018"
          iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">{t('iosDeveloper')}</h3>
          <h4 className="vertical-timeline-element-subtitle">{t('charlotte')}</h4>
          <p>{t('iosDeveloperDetails')}</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2017 - 2018"
          iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">{t('fullstackEngineer')}</h3>
          <h4 className="vertical-timeline-element-subtitle">{t('renton')}</h4>
          <p>{t('fullstackEngineerDetails')}</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;